<template>
	<v-badge
		:content="orders.length"
		:value="orders.length"
		color="red"
		overlap
	>
		<v-toolbar-items v-if="orders && orders.length > 0">
			<v-menu
				v-model="menu"
				open-on-hover
				:close-on-content-click="false"
				:nudge-width="200"
				offset-y
				nudge-bottom
				nudge-left
				origin="bottom left"
			>
				<template v-slot:activator="{ on, attrs }">
					<v-btn text v-bind="attrs" v-on="on">
						<v-icon left>mdi-cart</v-icon>
						<span class="hidden-md-and-down">
							{{ $t("label.active_orders") }}
						</span>
					</v-btn>
				</template>
				<v-card rounded max-width="500">
					<v-list>
						<Link
							as="v-list-item"
							link
							:href="$route('shop.orders.show', order.uuid)"
							v-for="(order, index) in orders"
							:key="index"
						>
							<v-list-item-avatar>
								<v-avatar color="secondary" dark>
									<v-icon
										v-if="order.type == 'delivery'"
										dark
									>
										mdi-moped
									</v-icon>
									<v-icon
										v-else-if="order.type == 'pickup'"
										dark
									>
										mdi-package
									</v-icon>
									<v-icon dark v-else>mdi-cart</v-icon>
								</v-avatar>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title>
									{{ $t("Code") }}: #{{ order.detail.code }} •
									{{ order.detail.type }}
								</v-list-item-title>
								<v-list-item-subtitle>
									{{ $t("Total") }}:
									{{ order.detail.total }} •
									{{ $t("label.items") }}:
									{{ order.detail.items_count }}
									<p
										v-if="
											order.driver &&
											order.type == 'delivery'
										"
									>
										{{ $t("label.driver") }}:
										{{ order.driver.name }} •
										{{ order.driver.phone }}
									</p>
								</v-list-item-subtitle>
							</v-list-item-content>

							<v-list-item-action>
								<v-chip>
									{{ $t("label." + order.detail.status) }}
								</v-chip>
							</v-list-item-action>
						</Link>
					</v-list>
				</v-card>
			</v-menu>
		</v-toolbar-items>
	</v-badge>
</template>

<script>
import { db } from "../../../plugins/firebase";
import { Link } from "@inertiajs/inertia-vue";
export default {
	components: {
		Link,
	},

	data() {
		return {
			menu: false,
			orders: [],
		};
	},

	computed: {
		uuid() {
			return this.$page.props.auth?.customer?.uuid;
		},
	},

	watch: {
		uuid: {
			handler(uuid) {
				if (uuid) {
					try {
						this.$bind(
							"orders",
							db
								.collection("orders")
								.where("customer.uuid", "==", uuid)
								.where("detail.status", "!=", "completed")
						);
					} catch (error) {
						this.$toast.error(error.message);
					}
				}
			},
			immediate: true,
		},
	},
};
</script>